import { NavLink } from 'react-router-dom';
import { cn } from '../../lib/utils';

const navItems = [
  { to: '/app/dashboard', label: 'Heute' },
  { to: '/app/courses', label: 'Kurse' },
  { to: '/app/statistics', label: 'Statistik' },
  { to: '/app/profile', label: 'Profil' },
];

/** Floating tab bar (mobile): card fill, 2.5 border, hard shadow, active = ink pill. */
export default function BottomNav() {
  return (
    <nav
      aria-label="Hauptnavigation"
      className="fixed inset-x-3.5 bottom-4 z-40 mx-auto max-w-md lg:hidden"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="grid h-[62px] grid-cols-4 gap-1 rounded-[22px] border-2.5 border-ink bg-cream p-1.5 shadow-hard">
        {navItems.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex h-full items-center justify-center rounded-[15px] font-mono text-[10.5px] font-bold uppercase tracking-[0.04em] transition-colors duration-200',
                  isActive ? 'bg-ink text-paper' : 'text-ink hover:bg-track'
                )
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
